export var RumEventType;

(function (RumEventType) {
  RumEventType["ACTION"] = "action";
  RumEventType["ERROR"] = "error";
  RumEventType["LONG_TASK"] = "long_task";
  RumEventType["VIEW"] = "view";
  RumEventType["RESOURCE"] = "resource";
})(RumEventType || (RumEventType = {}));